<h2 mat-dialog-title>{{ options.title }}</h2>

<mat-dialog-content>
    <form [formGroup]="form" autocomplete="off">
        <div class="top-fields">
            <div class="top-field-group">
                @if (form.controls.unlimited_usage.value) {
                    <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                        <mat-label>{{ 'enrollcode.usage-count' | translate }}</mat-label>
                        <input matInput [value]="'UNLIMITED' | translate" disabled>
                    </mat-form-field>
                } @else {
                    <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                        <mat-label>{{ 'enrollcode.usage-count' | translate }}</mat-label>
                        <input matInput type="number" formControlName="usage_count">
                        @if (form.controls.usage_count.hasError('required')) {
                            <mat-error>{{ 'enrollcode.usage-count-required' | translate }}</mat-error>
                        }
                        @if (form.controls.usage_count.hasError('invalidUsageCount')) {
                            <mat-error>{{ 'enrollcode.usage-count-invalid' | translate }}</mat-error>
                        }
                    </mat-form-field>
                }
                <mat-checkbox formControlName="unlimited_usage">{{ 'enrollcode.unlimited-usage' | translate }}</mat-checkbox>
            </div>
            <div class="top-field-group">
                @if (form.controls.perpetual.value) {
                    <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                        <mat-label>{{ 'enrollcode.expiration-date' | translate }}</mat-label>
                        <input matInput [value]="'NEVER' | translate" disabled>
                    </mat-form-field>
                } @else {
                    <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
                        <mat-label>{{ 'enrollcode.expiration-date' | translate }}</mat-label>
                        <input matInput [matDatepicker]="expirationPicker" formControlName="expires_dttm">
                        <mat-datepicker-toggle matIconSuffix [for]="expirationPicker"></mat-datepicker-toggle>
                        <mat-datepicker #expirationPicker></mat-datepicker>
                        @if (form.controls.expires_dttm.hasError('required')) {
                            <mat-error>{{ 'enrollcode.expiration-required' | translate }}</mat-error>
                        }
                        @if (form.controls.expires_dttm.hasError('expired')) {
                            <mat-error>{{ 'enrollcode.expiration-past' | translate }}</mat-error>
                        }
                        @if (form.controls.expires_dttm.hasError('invalidDate')) {
                            <mat-error>{{ 'enrollcode.expiration-invalid' | translate }}</mat-error>
                        }
                    </mat-form-field>
                }
                <mat-checkbox formControlName="perpetual">{{ 'enrollcode.no-expiration' | translate }}</mat-checkbox>
            </div>
        </div>
        <table mat-table [dataSource]="rows.controls" formArrayName="rows" class="enroll-table">
            <ng-container matColumnDef="endpoint">
                <th mat-header-cell *matHeaderCellDef>{{ 'ENDPOINT' | translate }}</th>
                <td
                    mat-cell
                    *matCellDef="let row; let i = index"
                    [formGroupName]="i">
                    {{ row.controls.endpointName.value }}
                </td>
            </ng-container>
            <ng-container matColumnDef="codeId">
                <th mat-header-cell *matHeaderCellDef>{{ 'enrollcode.code' | translate }}</th>
                <td
                    mat-cell
                    *matCellDef="let row; let i = index"
                    [formGroupName]="i">
                    <mat-form-field appearance="outline" class="code-field">
                        <input matInput formControlName="enroll_code_id">
                        @if (row.controls.enroll_code_id.hasError('required')) {
                            <mat-error>
                                {{ 'enrollcode.code-required' | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                </td>
            </ng-container>
            <ng-container matColumnDef="generate">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row; let i = index">
                    <div class="generate-button">
                        <button
                            type="button"
                            mat-raised-button
                            (click)="generateCode(i)">
                            {{ 'enrollcode.regenerate' | translate }}
                        </button>
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button
        mat-raised-button
        type="button"
        (click)="onCancel()">
        {{ 'CANCEL' | translate }}
    </button>
    <button
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="form.invalid"
        (click)="onCreateCodes()">
        {{ 'enrollcode.create-codes' | translate }}
    </button>
</mat-dialog-actions>